module.exports = __webpack_public_path__ + "img/teac_tn4d_disk.78de6d56.png";